var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<retailer-product-list retailer-id=\"{{ $ctrl.customer.id }}\" disable-query-string=\"true\"></retailer-product-list>";
var id1="cust-details.product-list.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;